import React from "react";
import { AlertTriangle } from "lucide-react";

const AlertsList = ({ alerts }) => {
  if (!alerts || alerts.length === 0) return null;

  return (
    <div className="mb-6">
      {alerts.map((alert, index) => (
        <div
          key={index}
          className={`flex items-center p-4 rounded-lg mb-2 ${
            alert.type === "danger"
              ? "bg-red-50 text-red-800 border border-red-200"
              : alert.type === "warning"
              ? "bg-yellow-50 text-yellow-800 border border-yellow-200"
              : "bg-blue-50 text-blue-800 border border-blue-200"
          }`}
        >
          <AlertTriangle size={20} className="mr-3" />

          <div className="flex-1">
            <h4 className="font-medium">{alert.title}</h4>
            <p className="text-sm">{alert.message}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default React.memo(AlertsList);